//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Portal.MyBusiness.PolicyList',
                {
                    url: '/PolicyList',
                    component: 'policyListComponent',
                    resolve: {}
                });
        }
    ]);

    app.component('policyListComponent', {
        templateUrl: 'App.Portal/States/MyBusiness/PolicyList/PolicyList.template.html',
        controller: 'PolicyListController',
        bindings: {
            user: "<",
            userGroup: "<",
            logo: "<",
            delegates: "<",
            onBehalfOfUser: "<",
        }
    });

    app.controller('PolicyListController', PolicyListController);

    PolicyListController.$inject = ['_', '$filter', 'figToaster', '$mdDialog', '$mdSidenav', 'newBusinessReportsApi', '$q', 'reportsApi', '$state', '$cookies', 'moment'];

    function PolicyListController(_, $filter, figToaster, $mdDialog, $mdSidenav, newBusinessReportsApi, $q, reportsApi, $state, $cookies, moment) {
        var $ctrl = this;

        ng.extend($ctrl, {
            user: Object.assign($ctrl.user, { selected: true }),
            exportingList: false,
            agentGuidListModel: {
                AgentIds: '',
                LobIds: [],
                StartDate: null,
                EndDate: null,
            },
            agents: [],
            lob: [
                { id: 1, name: "Annuity", selected: true },
                { id: 4, name: "Life", selected: false },
                { id: 2, name: "Long-term Care", selected: false }
            ],
            table: {
                headerDefault: [
                    {
                        displayName: 'Clients',
                        columnName: '[Clients[0], Clients[1], Clients[2]]',
                        widthClass: 'min-w-128',
                        reportTypes: ['Pending', 'Inforce'],
                    },
                    {
                        displayName: 'Policy',
                        columnName: '[Carrier, Product]',
                        widthClass: '',
                        reportTypes: ['Pending', 'Inforce'],
                    },
                    {
                        displayName: 'Premium',
                        columnName: 'SinglePremium',
                        widthClass: '',
                        reportTypes: ['Pending', 'Inforce'],
                    },
                    {
                        displayName: 'Face Amount',
                        columnName: 'FaceAmount',
                        widthClass: '',
                        reportTypes: ['Pending', 'Inforce'],
                    },
                    {
                        displayName: 'Target Premium',
                        columnName: 'Target',
                        widthClass: '',
                        reportTypes: ['Pending', 'Inforce'],
                    },
                    {
                        displayName: 'Ann. Premium',
                        columnName: 'AnnualizedPremium',
                        widthClass: '',
                        reportTypes: ['Pending', 'Inforce'],
                    },
                    {
                        displayName: 'Inforce Date',
                        columnName: 'InforceDate',
                        widthClass: '',
                        reportTypes: ['Inforce'],
                    },
                    {
                        displayName: 'Commision',
                        columnName: 'CommissionAmount',
                        widthClass: '',
                        reportTypes: ['Inforce'],
                    },
                    {
                        displayName: 'Latest Status',
                        columnName: 'PolicyStatusDate',
                        widthClass: 'min-w-256',
                        reportTypes: ['Pending', 'Inforce'],
                    },
                ],
                body: [],
            },
            columnName: 'PolicyStatusDate',
            reverseOrder: false,
        });

        function getFilters() {
            $ctrl.selectedAgentIds = $cookies.getObject("selected_agent_ids") ? $cookies.getObject("selected_agent_ids") : [$ctrl.user.AgentArcGuid];
            $ctrl.selectedReportType = $cookies.get("selected_report_type") ? $cookies.get("selected_report_type") : 'Pending';
            $ctrl.selectedLobIds = $cookies.getObject("selected_lob_ids") ? $cookies.getObject("selected_lob_ids") : [1];
            $ctrl.selectedDate = $cookies.getObject("selected_date") ? $cookies.getObject("selected_date") : {
                StartDate: new Date(new Date().getFullYear(), (new Date().getMonth() - 12), new Date().getDate()),
                EndDate: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate())
            };
            $ctrl.queryStartDate = $ctrl.selectedDate.StartDate;
            $ctrl.queryEndDate = $ctrl.selectedDate.EndDateDate;
        };

        function setFilters() {
            $cookies.putObject("selected_agent_ids", $ctrl.selectedAgentIds);
            $cookies.putObject("selected_lob_ids", $ctrl.selectedLobIds);
            $cookies.put("selected_report_type", $ctrl.selectedReportType);
            $cookies.putObject("selected_date", $ctrl.selectedDate);
        }

        function getLobList() {
            $ctrl.lob.forEach(function (x) {
                if ($ctrl.selectedLobIds.includes(x.id)) x.selected = true;
            })

            $ctrl.allLobSelected = areLengthsEqual($ctrl.selectedLobIds, $ctrl.lob);
        }

        function areLengthsEqual(array1, array2) {
            return array1.length == array2.length;
        }

        function getPolicies() {
            var promises = [];
            $ctrl.loadingRows = true;
            $ctrl.agentGuidListModel = Object.assign($ctrl.agentGuidListModel, {
                AgentIds: $ctrl.selectedAgentIds.join(','),
                LobIds: $ctrl.selectedLobIds,
                StartDate: $ctrl.selectedDate.StartDate,
                EndDate: $ctrl.selectedDate.EndDate,
            });

            switch ($ctrl.selectedReportType) {
                case 'Pending':
                    promises.push(newBusinessReportsApi.getPendingPolicies($ctrl.agentGuidListModel));
                    break;
                case 'Inforce':
                    promises.push(newBusinessReportsApi.getInforcePolicies($ctrl.agentGuidListModel));
                    break;
                default:
                    promises.push(newBusinessReportsApi.getPendingPolicies($ctrl.agentGuidListModel));
                    break;
            }

            $q.all(promises)
                .then(function (response) {
                    $ctrl.table.body = response[0];
                    $ctrl.orderRows();
                })
                .catch(function () {
                    var message = 'Sorry, an error has occured. Please try again later.',
                        toastClass = 'is-error';
                    figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {
                    $ctrl.loadingRows = false;
                });
        }

        function generateTableHeaders(selectedReportType) {
            $ctrl.selectedReportType = selectedReportType || $ctrl.selectedReportType;

            $ctrl.table.header = $ctrl.table.headerDefault.filter(function (cell) {
                return cell.reportTypes.includes($ctrl.selectedReportType);
            })
        }

        function downloadFile(data) {
            var f = document.createElement("a");
            f.id = "tmpDownload";
            document.body.appendChild(f);
            f.style = "display: none";

            var fUrl = window.URL.createObjectURL(data);
            f.href = fUrl;
            f.download = "PolicyData.xlsx";
            f.click();

            $ctrl.exportingList = false;

            setTimeout(function () {
                var el = document.getElementById(f.id);
                document.body.removeChild(el);
                window.URL.revokeObjectURL(fUrl);
            },
                100);
        }

        $ctrl.orderRows = function (columnName) {
            if (columnName) {
                $ctrl.reverseOrder = (columnName === $ctrl.columnName) ? !$ctrl.reverseOrder : false;
                $ctrl.columnName = columnName;
            } else {
                columnName = $ctrl.columnName;
            }
            $ctrl.table.body = $filter('orderBy')($ctrl.table.body, columnName, $ctrl.reverseOrder);
        };

        $ctrl.exportReport = function (selectedReportType) {
            if ($ctrl.table.body.length === 0) {
                var message = 'Nothing to export. Please select different filters.',
                    toastClass = 'is-default';
                return figToaster.showSimple(message, "top", toastClass);
            }
            $ctrl.exportingList = true;
            var agentGuidListModel = Object.assign($ctrl.agentGuidListModel, {
                AgentIds: $ctrl.selectedAgentIds.join(','),
                LobIds: $ctrl.selectedLobIds,
                StartDate: $ctrl.selectedDate.StartDate,
                EndDate: $ctrl.selectedDate.EndDate
            });
            if (selectedReportType === 'Pending') return newBusinessReportsApi.exportPendingPolicies(agentGuidListModel)
                .then(function (response) {
                    downloadFile(response);
                })
                .catch(function () {
                    var message = 'Sorry, an error has occured. Please try again later.',
                        toastClass = 'is-error';
                    figToaster.showSimple(message, "top", toastClass);
                    $ctrl.exportingList = false;
                });
            else if (selectedReportType === 'Inforce') return newBusinessReportsApi.exportInforcePolicies(agentGuidListModel)
                .then(function (response) {
                    downloadFile(response);
                })
                .catch(function () {
                    var message = 'Sorry, an error has occured. Please try again later.',
                        toastClass = 'is-error';
                    figToaster.showSimple(message, "top", toastClass);
                    $ctrl.exportingList = false;
                });
        };

        $ctrl.toggleReportType = function (selectedReportType) {
            if (selectedReportType === $ctrl.selectedReportType) return;

            $ctrl.selectedReportType = selectedReportType;
            setFilters();
            generateTableHeaders(selectedReportType);
            $ctrl.filterPolicyLists();
        };

        $ctrl.toggleCheckbox = function (array, selectedArray, type, item) {
            var id = item.ChildAgentGuid || item.AgentId || item.id;
            var index = selectedArray.indexOf(id);

            if (item.selected && index === -1) selectedArray.push(id);
            else selectedArray.splice(index, 1);

            if (type === 'Agent') $ctrl.allAgentsSelected = areLengthsEqual(selectedArray, array);
            if (type === 'Lob') $ctrl.allLobSelected = areLengthsEqual(selectedArray, array);

            setFilters();
            $ctrl.filterPolicyLists();
        };

        $ctrl.toggleAllCheckboxes = function (array, selectedArray, type, allSelected) {
            if (allSelected) {
                array.forEach(function (item) {
                    //add additional id props here
                    var id = item.ChildAgentGuid || item.AgentId || item.id;
                    //check for duplicate entries
                    var isDuplicate = selectedArray.indexOf(id) > - 1;
                    item.selected = true;

                    if (!isDuplicate) selectedArray.push(id);
                });
            } else {
                array.forEach(function (item) {
                    item.selected = false;
                });

                if (type === 'Agent') $ctrl.selectedAgentIds = [];
                if (type === 'Lob') $ctrl.selectedLobIds = [];
            }

            setFilters();
            $ctrl.filterPolicyLists();
        };

        $ctrl.openRequirementModel = function (policy, event) {
            $mdDialog.show({
                targetEvent: event,
                controller: "OpenRequirementController",
                controllerAs: "$ctrl",
                templateUrl: "/App.Portal/Modals/OpenRequirement/OpenRequirement.template.html",
                bindToController: true,
                resolve: {
                    policy: [function () { return policy; }]
                }
            });
        };

        $ctrl.toggleNav = function (navId) {
            $mdSidenav(navId).toggle();
        };

        var getAllPoliciesUnfiltered = function (agents) {
            var agentGuidListModel = Object.assign($ctrl.agentGuidListModel, {
                AgentIds: $ctrl.agents.map(function (a) {
                    return a.ChildAgentGuid != null ? a.ChildAgentGuid : a.AgentId;
                }).join(','),
                LobIds: $ctrl.lob.map(function (l) { return l.id; }),
                StartDate: $ctrl.selectedDate.StartDate,
                EndDate: $ctrl.selectedDate.EndDate
            });

            newBusinessReportsApi.getPendingPolicies(agentGuidListModel).then(function (response) {
                $ctrl.allPendingPolicies = response;
            });

            newBusinessReportsApi.getInforcePolicies(agentGuidListModel).then(function (response) {
                $ctrl.allInforcePolicies = $filter('orderBy')(response,'InforceDate');
            });
        };
        var createAgentList = function (data) {
            if (data.length) {
                $ctrl.agents = data.map(function (agent) {
                    return Object.assign(agent, {
                        selected: $ctrl.selectedAgentIds.includes(agent.ChildAgentGuid) ? true : false
                    });
                });

                $ctrl.agents = $filter('orderBy')($ctrl.agents, 'FirstName');
            }

            $ctrl.agents.unshift({
                FirstName: $ctrl.user.FirstName,
                LastName: $ctrl.user.LastName,
                AgentId: $ctrl.user.AgentArcGuid,
                CurrentUserTag: '(Me)',
                selected: $ctrl.selectedAgentIds.includes($ctrl.user.AgentArcGuid) ? true : false
            });

            $ctrl.allAgentsSelected = areLengthsEqual($ctrl.selectedAgentIds, $ctrl.agents);
            return $ctrl.agents;
        };

        var pendingPolicyFilterFn = function (value, index, array) {
            return lobMatch(value) && agentMatch(value);
        };

        var inforcePolicyFilterFn = function (value, index, array) {
            return lobMatch(value) && agentMatch(value) && dateMatch(value);
        };

        var lobMatch = function (value) {
            var match = false;
            if ($ctrl.selectedLobIds && $ctrl.selectedLobIds.length > 0) {
                match = $ctrl.selectedLobIds.some(function (l) {
                    return l === value.LineOfBusinessId;
                });
            }
            return match;
        };

        var agentMatch = function (value) {
            var match = false;
            if ($ctrl.selectedAgentIds && $ctrl.selectedAgentIds.length > 0) {
                match = $ctrl.selectedAgentIds.some(function (a) {
                    return (a.replace(/[{}]/g, "").toLowerCase() === value.AgentGuid.replace(/[{}]/g, "").toLowerCase())
                        || (value.AssociatedPortalAgentGUIDS != null ? value.AssociatedPortalAgentGUIDS.split(',').some(function (aa) {
                            return a.replace(/[{}]/g, "").toLowerCase() === aa.replace(/[{}]/g, "").toLowerCase();
                        }) : false);
                });
            }
            return match;
        };

        var dateMatch = function (value) {
            return moment(value.InforceDate).isAfter(moment($ctrl.selectedDate.StartDate)) && moment(value.InforceDate).isBefore(moment($ctrl.selectedDate.EndDate));
        };

        $ctrl.onDateRangeChange = function () {

            setFilters();

            if ($ctrl.selectedReportType === 'Inforce' && $ctrl.allInforcePolicies && $ctrl.allInforcePolicies.length > 0) {

                // if the new dates are outside of date range of InforcePolic
                if (moment($ctrl.selectedDate.StartDate).isBefore(moment($ctrl.queryStartDate))
                    || moment($ctrl.selectedDate.StartDate).isAfter(moment($ctrl.queryEndDate))
                    || moment($ctrl.selectedDate.EndDate).isAfter(moment($ctrl.queryEndDate))
                    || moment($ctrl.selectedDate.EndDate).isBefore(moment($ctrl.queryStartDate))) {


                    var agentGuidListModel = Object.assign($ctrl.agentGuidListModel, {
                        AgentIds: $ctrl.agents.map(function (a) {
                            return a.ChildAgentGuid != null ? a.ChildAgentGuid : a.AgentId;
                        }).join(','),
                        LobIds: $ctrl.lob.map(function (l) { return l.id; }),
                        StartDate: $ctrl.selectedDate.StartDate,
                        EndDate: $ctrl.selectedDate.EndDate
                    });

                    newBusinessReportsApi.getInforcePolicies(agentGuidListModel).then(function (response) {
                        $ctrl.queryStartDate = $ctrl.selectedDate.StartDate;
                        $ctrl.queryEndDate = $ctrl.selectedDate.EndDate;
                        $ctrl.allInforcePolicies = $filter('orderBy')(response, 'InforceDate');
                        $ctrl.filterPolicyLists();
                    });
                } else {
                    $ctrl.filterPolicyLists();
                }
            }
        };

        $ctrl.filterPolicyLists = function () {
            if ($ctrl.selectedReportType === 'Pending') {
                $ctrl.table.body = $filter('filter')($ctrl.allPendingPolicies, pendingPolicyFilterFn);
            } else {
                // Inforce

                $ctrl.table.body = $filter('filter')($ctrl.allInforcePolicies, inforcePolicyFilterFn);
            }

            $ctrl.orderRows();
        };

        $ctrl.$onInit = function () {
            getFilters();
            generateTableHeaders();
            reportsApi.getSubAgents()
                .then(createAgentList)
                .then(getAllPoliciesUnfiltered);
            getLobList();
            getPolicies();
        };
    }
})(window.angular, window.app);